import styled from 'styled-components';
import { body2, textColors, colors, spacing, fontWeights, caption } from 'ui/theme';
import { pxToRem } from 'utils/convert';
import { TableCell } from 'ui/tableCell';
import { Link } from 'ui/links';
import { HeaderGridRow } from 'ui/indexPages/tables/grid';
import { GridRow } from 'ui/indexPages/tables/grid';

/** GridRows */
export const StyledHeaderGridRow = styled(HeaderGridRow)`
  align-items: center;
  margin-top: ${spacing.plusHalf};
`;

export const StyledGridRow = styled(GridRow)`
  align-items: center;
  height: ${pxToRem(96)};
  padding: 0 ${spacing.layoutLRPadding};
`;

/** Cell Components */
export const StyledTableCell = styled(TableCell)`
  padding: 0;
`;

/** Name Cell Components */
export const FirstTier = styled(Link)`
  color: ${colors.textPrimary};
  font-weight: 400;
  text-decoration-color: transparent;
`;

export const SecondTier = styled.div`
  ${body2};
  color: ${textColors.textSecondary};
  line-height: ${spacing.base};
  font-size: ${spacing.threeQuarter};
  white-space: nowrap;

  display: flex;
  flex-direction: row;
  column-gap: ${spacing.quarter};
  align-items: center;

  > * + * {
    :before {
      color: ${colors.grey35};
      content: '\\2219'; /** unicode for bullet operators */
      margin-right: ${spacing.eighth};
      font-weight: ${fontWeights.semiBold};
    }
    margin-left: ${spacing.eighth};
  }
`;

export const Description = styled.span`
  overflow: hidden;
  text-overflow: ellipsis;
`;

/** Users Cell Components */
export const NotAvailableLabel = styled.div`
  ${caption}
  color: ${colors.textSecondary}
`;
